import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { Toggle } from '../ui/toggle';

const DarkModeToggle = ({ darkMode, toggleDarkMode }) => {
  return (
    <Toggle
      pressed={darkMode}
      onPressedChange={toggleDarkMode}
      size="sm"
      className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground [@media(hover:hover)_and_(pointer:fine)]:hover:shadow-md"
      aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
    >
      {darkMode ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
    </Toggle>
  );
};

export default DarkModeToggle;
